window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('./components/header'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./account/account'));
    processInclude(require('./components/quote'));
    processInclude(require('./compare'));
    processInclude(require('./swatches'));
    processInclude(require('./components/carousel'));
    processInclude(require('./chatbot'));
    processInclude(require('./login'));
});

require('base/thirdParty/bootstrap');
require('./components/spinner');
